module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"buttons":{"request":"Solicitar","cancel":"Cancelar"},"alert":{"sucess-request":"Solcitado com sucesso"}},"en-US":{"buttons":{"request":"Request","cancel":"Cancel"},"alert":{"sucess-request":"Request sent successfully"}}}')
  delete Component.options._Ctor
}
